import { render, staticRenderFns } from "./PieChartOutlined.vue?vue&type=template&id=60d8ec28&"
import script from "./PieChartOutlined.vue?vue&type=script&lang=js&"
export * from "./PieChartOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports